<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="8" class="text-center">
          <h1 class="display-2 font-weight-bold mb-3">Dental Portal'a Hoş Geldiniz</h1>
          <p class="subtitle-1">Diş hekimliği sektörüne özel duyurular, haberler ve eğitimler.</p>
           <v-btn color="primary" large to="/announcements" class="mt-5">
              Duyuruları İncele <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
  
       <v-divider class="my-8"></v-divider>
  
       <v-row>
         <v-col cols="12">
           <h2 class="headline mb-4">Son Duyurular</h2>
           <p class="text-center grey--text">Yakında...</p>
         </v-col>
       </v-row>
  
       </v-container>
  </template>
  
  <script>
  // import AnnouncementsList from '@/components/AnnouncementsList.vue'; // Örnek
  
  export default {
    name: 'HomeView',
    components: {
     // AnnouncementsList
    }
  };
  </script>